
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/education/board-results/jharkhand-board-12th-result",
      function () {
        return require("private-next-pages/education/board-results/jharkhand-board-12th-result.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/education/board-results/jharkhand-board-12th-result"])
      });
    }
  